import { render } from "./EntityHero.vue?vue&type=template&id=20adb91c&scoped=true&ts=true"
import script from "./EntityHero.vue?vue&type=script&lang=ts"
export * from "./EntityHero.vue?vue&type=script&lang=ts"

import "./EntityHero.vue?vue&type=style&index=0&id=20adb91c&lang=scss&scoped=true"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20adb91c"]])

export default __exports__